module.exports = __webpack_public_path__ + "img/feature_buy_ph.f96e7e1d.png";